/*
 * PRX carousel: one engine for every horizontal swipe row on the site (reviews, reason cards, customer videos, and
 * any future section). Content-agnostic: it only needs attributes, so any section can opt in.
 *
 *   <div class="prx-car [prx-car--center] [prx-car--mobile]" data-prx-car [data-prx-car-center] [data-prx-car-videos]>
 *     <div class="prx-car__track" data-prx-car-track> …any slides as direct children… </div>
 *     {% render 'prx-carousel-controls', label: 'reviews' %}
 *   </div>
 *
 * data-prx-car-center  the active slide snaps to the middle (pair with .prx-car--center)
 * data-prx-car-loop    endless: copies of the slides sit on both sides, so there is always a slide to the left and the
 *                      arrows never stop; after each move the track jumps silently back to the real slides (off in the theme editor)
 * data-prx-car-videos  play the <video> in a slide while it is mostly in view, pause it when it leaves; a video the
 *                      viewer paused (data-user-paused="1" on the <video>) is left alone
 * .prx-car--mobile     CSS-only: the section's own layout from 750px up, a carousel on phones (749px and below, Broadcast's
 *                      breakpoint); where nothing scrolls the engine marks the carousel .is-static, which hides the controls.
 * .prx-car--desktop    CSS-only: the reverse, a carousel from 750px up and the section's own grid on phones.
 * .prx-car--cols       CSS-only: slides sized like Broadcast's grid, N per row from --COLUMNS / --COLUMNS-MEDIUM (set by
 *                      the section, see snippets/prx-section-vars); phones get one slide plus a 50px peek.
 * Sets .is-active on the current slide and .is-static on the root when everything fits. Safe to load many times.
 */
(function () {
  if (window.PRXCarousel) { window.PRXCarousel.initAll(); return; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.prxCarReady) return;
    var track = root.querySelector('[data-prx-car-track]');
    if (!track) return;
    root.dataset.prxCarReady = '1';
    if (!track.hasAttribute('tabindex')) track.setAttribute('tabindex', '0');
    var prev = root.querySelector('[data-prx-car-prev]');
    var next = root.querySelector('[data-prx-car-next]');
    var dots = root.querySelector('[data-prx-car-dots]');
    var center = root.hasAttribute('data-prx-car-center');
    var n = 0;   // number of real slides when looping
    var designMode = window.Shopify && window.Shopify.designMode;
    if (root.hasAttribute('data-prx-car-loop') && !designMode) {
      var real = [].slice.call(track.children);
      if (real.length > 1) {
        n = real.length;
        var mk = function (el) {
          var c = el.cloneNode(true);
          c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-prx-car-clone', ''); c.inert = true;
          c.removeAttribute('id'); c.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
          c.querySelectorAll('a,button,[tabindex]').forEach(function (x) { x.setAttribute('tabindex', '-1'); });
          return c;
        };
        var first = real[0];
        real.forEach(function (el) { track.insertBefore(mk(el), first); });
        real.forEach(function (el) { track.appendChild(mk(el)); });
      }
    }

    function slides() {
      return [].filter.call(track.children, function (el) { return el.getClientRects().length > 0; });
    }
    function padStart() { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; }
    function anchorOf(el) { var r = el.getBoundingClientRect(); return center ? r.left + r.width / 2 : r.left; }
    function target() { var t = track.getBoundingClientRect(); return center ? t.left + t.width / 2 : t.left + padStart(); }
    function index() {
      var s = slides(), ref = target(), best = 0, bestD = Infinity;
      s.forEach(function (el, i) { var d = Math.abs(anchorOf(el) - ref); if (d < bestD) { bestD = d; best = i; } });
      return best;
    }
    function realIndex(i) { return n ? ((i % n) + n) % n : i; }
    function jump(px) {   // instant move, no smooth scrolling and no snap animation
      var b = track.style.scrollBehavior; track.style.scrollBehavior = 'auto'; track.scrollLeft += px; track.style.scrollBehavior = b;
    }
    function go(i) {
      var s = slides();
      if (!s.length) return;
      i = Math.max(0, Math.min(i, s.length - 1));
      track.scrollBy({ left: anchorOf(s[i]) - target(), behavior: reduce ? 'auto' : 'smooth' });
    }
    function normalize() {   // loop: once a move ends on a copy, jump to the same slide in the real set
      if (!n) return;
      var s = slides(); if (s.length !== 3 * n) return;
      var i = index();
      if (i < n) jump(anchorOf(s[i + n]) - anchorOf(s[i]));
      else if (i >= 2 * n) jump(anchorOf(s[i - n]) - anchorOf(s[i]));
    }
    function buildDots() {
      if (!dots) return;
      dots.innerHTML = '';
      var count = n || slides().length;
      for (var i = 0; i < count; i++) (function (i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'prx-car__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { var cur = index(); go(cur - realIndex(cur) + i); });
        dots.appendChild(b);
      })(i);
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-static', max <= 2);
      var s = slides(), i = index();
      if (prev) prev.disabled = !n && track.scrollLeft <= 2;
      if (next) next.disabled = !n && track.scrollLeft >= max - 2;
      s.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      var r = realIndex(i);
      if (dots) {
        if (dots.children.length !== (n || s.length)) buildDots();
        [].forEach.call(dots.children, function (d, k) {
          d.classList.toggle('is-on', k === r);
          if (k === r) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
    }
    var raf = 0, settle = 0;
    function queue() {
      cancelAnimationFrame(raf); raf = requestAnimationFrame(sync);
      if (n) { clearTimeout(settle); settle = setTimeout(normalize, 140); }
    }

    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () {
      if (n) { var r = realIndex(index()), s = slides(); if (s[n + r]) jump(anchorOf(s[n + r]) - target()); }
      queue();
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });

    if (root.hasAttribute('data-prx-car-videos') && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.querySelector('video');
          if (!v) return;
          if (e.isIntersecting) { if (v.dataset.userPaused === '1') return; var p = v.play(); if (p && p.catch) p.catch(function () {}); e.target.classList.add('is-playing'); }
          else { v.pause(); e.target.classList.remove('is-playing'); }
        });
      }, { threshold: 0.6 });   // viewport root: the track's overflow still clips, so off-screen and off-track clips both pause
      slides().forEach(function (el) { if (el.querySelector('video')) io.observe(el); });
    }

    buildDots();
    if (n) {   // start on the first real slide, with the last one already showing on the left
      var start = function () { var s = slides(); if (s[n]) jump(anchorOf(s[n]) - target()); sync(); };
      start(); requestAnimationFrame(start); window.addEventListener('load', start, { once: true });
    }
    sync();
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-prx-car]').forEach(init); }
  window.PRXCarousel = { init: init, initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
